import { ColorType } from 'common/types/color-type'

export default function (color: ColorType) {
  if (color.includes('gradient')) {
    return `text-${color}`
  }
  return `color-${color}`
}
